import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex items-center">
          <img
            src="https://public.readdy.ai/ai/img_res/ba9a4540-6b56-475b-a9de-4519f7b4e3c0.png"
            alt="A A D LIMA VERDE LTDA"
            className="h-12 w-auto"
          />
        </div>
        <div className="flex items-center gap-8">
          <button
            onClick={() => scrollToSection('home')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            Home
          </button>
          <button
            onClick={() => scrollToSection('features')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            Features
          </button>
          <button
            onClick={() => scrollToSection('security')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            Security & Privacy
          </button>
          <button
            onClick={() => scrollToSection('how-it-works')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            How It Works
          </button>
          <button
            onClick={() => scrollToSection('about')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            About
          </button>
          <button
            onClick={() => scrollToSection('contact')}
            className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white hover:text-blue-300'
            }`}
          >
            Contact
          </button>
        </div>
      </div>
    </nav>
  );
}
